import { LocalDateTime } from 'js-joda';

import { toDateTimeString } from 'utils/timeUtils';

// If you are changing either of these also change this in TockConstants.java in the server.
export const businessDayTimeCutOff = '04:00';
export const BUSINESS_LOCK_DURATION = 10;

export function adjustDateForCutOff(date: string, time: string): LocalDateTime {
  return LocalDateTime.parse(toDateTimeString(date, time)).plusDays(
    time < businessDayTimeCutOff ? 1 : 0
  );
}
